<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="false" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
      </template>

      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('billingPage.create') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'profitMarginFrom'"> {{ `${scope.row.profitMarginFrom}% <= Margin < ${scope.row.profitMarginTo}%` }}</template>
              <template v-else-if="col.prop === 'salesTurnoverFrom'">{{ `${scope.row.salesTurnoverFrom} <= Turnover < ${scope.row.salesTurnoverTo}` }}</template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
              <el-button type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <el-dialog :title="``" :visible.sync="dialogFormVisible" width="450px">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-form-item prop="tierName" :label="$t('billingPage.tierName')">
          <BjInput v-model="form.tierName" style="width: 400px;" />
        </el-form-item>
        <el-form-item prop="profitMarginTo" :label="$t('billingPage.ProfitMargin')">
          <el-row class="flex-align">
            <el-input
                v-model="form.profitMarginFrom" :controls="false" :placeholder="$t('inputText')"
                onkeyup="this.value = this.value.replace(/[^\d.-]/g,'');" style="width:140px;"
            ><template slot="append">%</template></el-input>
            <div style="width:120px;text-align: center;">{{ `<= Margin <` }} </div>
            <el-input
                v-model="form.profitMarginTo" :controls="false" :placeholder="$t('inputText')"
                onkeyup="this.value = this.value.replace(/[^\d.-]/g,'');" style="width:140px;"
            ><template slot="append">%</template></el-input>
          </el-row>
        </el-form-item>
        <el-form-item prop="salesTurnoverTo" :label="$t('billingPage.salesTurnoverFrom')">
          <el-row class="flex-align">
            <BjInputMoney v-model="form.salesTurnoverFrom" :min="0" style="width: 140px;" /> <div style="width:120px;text-align: center;">{{ `<= Turnover <` }}</div> <BjInputMoney v-model="form.salesTurnoverTo" :min="0" style="width: 140px;" />
          </el-row>
        </el-form-item>
        <el-form-item prop="tierName" :label="$t('table.countText')">
          <BjInputNumber v-model="form.sortNo" style="width: 400px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="comfirm()">{{ $t('okText') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { billApi } from '@/api';
  const defaultForm = () =>{
    return {
      tierName: null,
      profitMarginFrom: null,
      profitMarginTo: null,
      salesTurnoverFrom: null,
      salesTurnoverTo: null,
      sortNo: null,
    }
  }
  export default {
    name: 'BusinessBillingTierSetting',
    mixins: [pageMiXin],
    data() {
      const validate1 = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t('inputText')));
        } else if (Number(this.form.profitMarginFrom) >= Number(this.form.profitMarginTo)) {
          callback(new Error(this.$t('businessLogisticsCompanyFreight.Add.rightText1')));
        } else {
          callback();
        }
      };
      const validate2 = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t('inputText')));
        } else if (Number(this.form.salesTurnoverFrom) >= Number(this.form.salesTurnoverTo)) {
          callback(new Error(this.$t('businessLogisticsCompanyFreight.Add.rightText1')));
        } else {
          callback();
        }
      };
      return {
        colSpan: 4,
        queryApi: billApi.getClientTierList,
        queryParams: {
        },
        labelList: [
          { label: this.$t('table.countText'), prop: 'sortNo', isCheck: true, disabled: false },
          { label: this.$t('billingPage.tierName'), prop: 'tierName', isCheck: true, disabled: false },
          { label: this.$t('billingPage.ProfitMargin'), prop: 'profitMarginFrom', isCheck: true, disabled: false },
          { label: this.$t('billingPage.salesTurnoverFrom'), prop: 'salesTurnoverFrom', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
        ],
        dialogFormVisible: false,
        form: defaultForm(),
        rules: {
          tierName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          profitMarginTo: [{ required: true, validator: validate1, trigger: 'blur' }],
          salesTurnoverTo: [{ required: true, validator: validate2, trigger: 'blur' }],
          sortNo: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        }
      };
    },
    computed: {},
    watch: {
    },
    mounted() {
    },
    methods: {
      onEdit(item) {
        this.dialogFormVisible = true;
        this.form = JSON.parse(JSON.stringify(item))
      },
      comfirm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const api = this.form.id ? 'updateClientTier' : 'addClientTier'
            billApi[api](this.form).then(() => {
              this.dialogFormVisible = false;
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
            });
          }
        });
      },
      onAdd() {
        this.dialogFormVisible = true
        this.form = defaultForm()
      },
      onDelete(row) {
        this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(() => {
          billApi.deleteClientTier({id: row.id}).then(() => {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
          });
        })
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
